import { render, staticRenderFns } from "./InterviewCoach.vue?vue&type=template&id=ec0edc74&scoped=true&"
import script from "./InterviewCoach.vue?vue&type=script&lang=js&"
export * from "./InterviewCoach.vue?vue&type=script&lang=js&"
import style0 from "./InterviewCoach.vue?vue&type=style&index=0&id=ec0edc74&scoped=true&lang=css&"
import style1 from "../../constant/css/detail.css?vue&type=style&index=1&id=ec0edc74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0edc74",
  null
  
)

export default component.exports